import CoachesSearchSection from './coaches-search-section'

export default CoachesSearchSection
